import { FC } from 'react';
import './index.scss';

const SuccessBadge: FC = () => {
  return <div className='success-badge'/>
}

export default SuccessBadge;